import { getFakeAppointments } from './fakedata';

export const getAllAppointements = () => {
  return {
    data: getFakeAppointments(),
  };
};
